import React from 'react';

// station-anon-login-prompt: what an anonymous visitor sees on a station page
// instead of a spinner that never resolves.
//
// WHY it never resolves, and WHEN this renders, live in ONE place:
// `shouldShowAnonLoginPrompt` in ChatInterface.js. Deliberately not restated here --
// the first version of this comment described a stalled handshake that the live test
// disproved (the socket reaches 'live'; the typing dots are what spin), and a
// confident wrong explanation outlived the code it described. A pointer cannot rot
// the same way.
//
// This component is presentation only. The caller owns every decision: whether to
// show it at all, and what Sign in does.
const AnonLoginPrompt = ({ onSignIn, stationName }) => (
  <div
    role="status"
    aria-label="Sign in required"
    style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: '14px', padding: '32px 20px',
      textAlign: 'center', margin: 'auto', maxWidth: '420px',
    }}
  >
    <div style={{ fontSize: '1.02rem', fontWeight: 600, color: '#334155' }}>
      Sign in to join{stationName ? ` ${stationName}` : ' this station'}
    </div>
    <div style={{ fontSize: '0.86rem', color: '#64748b', lineHeight: 1.5 }}>
      This station needs an account. Sign in and the conversation will open
      straight away.
    </div>
    <button
      type="button"
      onClick={onSignIn}
      style={{
        marginTop: '2px', padding: '9px 20px', fontSize: '0.9rem',
        fontWeight: 600, color: '#ffffff', background: '#2563eb',
        border: 'none', borderRadius: '10px', cursor: 'pointer',
      }}
    >
      Sign in
    </button>
  </div>
);

export default AnonLoginPrompt;
